export default __webpack_public_path__ + "static/Inter-BoldItalic-b376885042f6c961a5419d10d0bd3bf4.woff";